import { useDispatch, useSelector } from "react-redux";
import { getSelectedContainers } from "../../data/selectedcontainers";
import { getSelectedTerminalCalls } from "../../data/selectedterminalcalls";
import { getVoyage } from "../../data/voyage";
import { normalizeIds } from "../utils/normalize";
import { selectedFilteredTerminalCall } from "../../selectors/filterSelector";
import { removeSelectedTerminalCallFilterValue } from "../../data/filter";

export const useRefreshVoyageData = () => {
  const dispatch = useDispatch();
  const filteredTerminalCall = useSelector(selectedFilteredTerminalCall);

  return async (voyage: any, options?: { force?: boolean }) => {
    if (!voyage?.["@id"]) return;

    const force = Boolean(options?.force);

    const voyageId = voyage["@id"].split("/").pop();
    const updatedVoyage = await dispatch(getVoyage(voyageId));

    if (
      !Array.isArray(updatedVoyage?.containers) ||
      !Array.isArray(updatedVoyage?.terminalCalls)
    ) {
      return;
    }

    const containerIds = normalizeIds(updatedVoyage.containers);
    const terminalCallIds = normalizeIds(updatedVoyage.terminalCalls);

    dispatch(getSelectedContainers(containerIds, { force }));
    dispatch(getSelectedTerminalCalls(terminalCallIds, { force }));

    if (filteredTerminalCall?.["@id"]) {
        dispatch(removeSelectedTerminalCallFilterValue());
    }
  };
};